import styled from 'styled-components';
import { Badge } from './Badge.styled';
export const BadgeNewStyled = styled(Badge) `
  background-color: ${({ theme }) => theme.colorsV2.ui.support.success};
  padding: 4px 6px;
`;
export const BadgeNewWrapper = styled.div `
  min-width: 24px;
  height: 26px;
  display: flex;
  align-items: center;
`;
export const BadgeNewNavDesktop = styled(BadgeNewStyled) `
  position: absolute;
  top: 4px;
  right: -10px;
  &::before {
    content: 'New';
  }
`;
export const BadgeNewPanel = styled(BadgeNewStyled) `
  position: absolute;
  top: 16px;
  left: 16px;
  &::before {
    content: 'New';
  }
`;
export const BadgeNewPanelInlineWrapper = styled.div `
  display: inline-block;
  position: relative;
  &::before {
    content: 'New';
  }
`;
//# sourceMappingURL=BadgeNew.styled.js.map